<template>
  <div class="compound banner public-content">
    <div class="breadcrumb">首页模块管理</div>
    <div class="right-main">
      <div class="data-list">
        <div class="main-content">
          <div class="banner-table">
            <el-table border class="table-cell" :data="tableList">
              <el-table-column label="模块名称">
                <template slot-scope="scope">
                  <!-- :style="clickId === scope.row.id ? 'color:#409EFF' : 'color:#bfbfbf'" -->
                  <i class="el-icon-s-unfold"></i>
                  <span style="margin-left: 10px">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="enable" label="是否展示">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.enable" :active-value="0" :inactive-value="1" @change="enableChange(scope.row)">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template v-slot="scope">
                  <span class="color-blue" @click="detail(scope.row)">编辑</span>
                </template>
              </el-table-column>
            </el-table>
            <div style="color:red">注：拖<i class="el-icon-s-unfold" style="color:#bfbfbf"></i>可调整滑块顺序</div>
            <div class="form-btn" style="margin: 20px 0" v-if="isDrop">
              <el-button round @click="cancel()" v-preventReClick>取消</el-button>
              <el-button round type="primary" @click="submit()" v-preventReClick>保存</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="编辑" :visible.sync="dialogVisible" width="30%" v-if="dialogVisible">
      <div style="display:flex;align-items: center;">
        <span>模块名称：</span>
        <div style="width: 180px;">
          <el-input v-model="modelEdit.name" placeholder="请输入内容"></el-input>
        </div>
      </div>
      <div style="font-size: 12px;color:red;margin-left: 80px;" v-if="haveName">名称已被占用，另起一个吧</div>
      <span slot="footer" class="dialog-footer">
        <el-button round type="primary" @click="save()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { appModuleList, updateModuleName, updateModuleInfo } from '@/api/pms'
import Sortable from 'sortablejs'
export default {
  name: 'banner',
  data () {
    return {
      modelEdit: {},
      haveName: false,
      dialogVisible: false,
      isDrop: false,
      clickId: 0,
      tableList: [],
      formInline: {
        type: null
      },
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      types: [{
        label: '新品发布',
        value: '0'
      }, {
        label: '项目展示',
        value: '1'
      }
        //  {
        //   label: 'C端活动推广',
        //   value: '2'
        // }
      ],
      form: {},
      where: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      tableData: [],
      tableDataStatus: {
        spuName: '', // 产品名称
        categoryId: '', // 产品类别
        isSeries: '', // 产品属性
        spuProperty: ''// 产品性质
      }
    }
  },
  computed: {
    // prodName () {
    //   return (val) => {
    //     let str = ''
    //     let obj = this.tableData.find(v => v.id === val.relationId)
    //     str = obj?.spuName
    //     return str
    //   }
    // }
  },
  mounted () {
    // 阻止默认行为
    document.body.ondrop = function (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    // 调用 table拖拽排序
    this.rowDrop()
  },
  async created () {
    await this.getAppModuleList()
  },
  methods: {
    enableChange (val) {
      console.log('val', val)
      updateModuleInfo([val]).then(res => {
        console.log('res', res)
        if (res.data.success) {
          if (this.isDrop) {
            this.$message.success('保存成功')
            this.clickId = 0
            this.isDrop = false
          }
        }
        this.getAppModuleList()
      })
    },
    // 行拖拽
    rowDrop () {
      let tbody = document.querySelector('.el-table__body-wrapper tbody')
      let _this = this
      Sortable.create(tbody, {
        // or { name: "...", pull: [true, false, 'clone', array], put: [true, false, array] }
        group: {
          name: 'words',
          pull: true,
          put: true
        },
        animation: 150, // ms, number 单位：ms，定义排序动画的时间
        onAdd: function (evt) { // 拖拽时候添加有新的节点的时候发生该事件
          console.log('onAdd.foo:', [evt.item, evt.from])
        },
        onUpdate: function (evt) { // 拖拽更新节点位置发生该事件
          console.log('onUpdate.foo:', [evt.item, evt.from])
        },
        onRemove: function (evt) { // 删除拖拽节点的时候促发该事件
          console.log('onRemove.foo:', [evt.item, evt.from])
        },
        onStart: function (evt) { // 开始拖拽出发该函数
          // this.clickId = evt
          console.log('onStart.foo', evt.oldIndex)
          let aaaa = _this.tableList[evt.oldIndex]
          console.log('aaaa', aaaa)
          _this.clickId = aaaa.id
        },
        onSort: function (evt) { // 发生排序发生该事件
          console.log('onUpdate.foo:', [evt.item, evt.from])
        },
        // 一般的业务就用onEnd结束拖拽就够了
        onEnd ({ newIndex, oldIndex }) { // 结束拖拽
          if (newIndex == oldIndex) return
          let currRow = _this.tableList.splice(oldIndex, 1)[0]
          // console.log('currRow', newIndex, currRow)
          _this.tableList.splice(newIndex, 0, currRow)
          let newArray = _this.tableList.splice(0)
          _this.$nextTick(() => {
            _this.isDrop = true
            _this.tableList = newArray
            console.log('onEnd', _this.tableList)
          })
        }
      })
    },
    async getAppModuleList () {
      await appModuleList({}).then(res => {
        if (res.data.success) {
          let dataList = res.data.data
          this.tableList = dataList
          this.tableData = Object.assign([], dataList)
          // this.queryInfo.total = res.data.data.total
        }
      })
    },
    detail (val) {
      this.dialogVisible = true
      this.modelEdit = Object.assign({}, val)
    },
    cancel () {
      this.clickId = 0
      this.isDrop = false
      this.tableList = Object.assign([], this.tableData)
    },
    submit () {
      let param = this.tableList.map((a, i) => {
        return {
          ...a,
          sort: i + 1
        }
      })
      updateModuleInfo(param).then(res => {
        console.log('res', res)
        if (res.data.success) {
          this.$message.success('保存成功')
          this.clickId = 0
          this.isDrop = false
          this.getAppModuleList()
        }
      })
    },
    // 编辑名称保存
    save () {
      updateModuleName(this.modelEdit).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.haveName = false
          this.getAppModuleList()
        } else {
          this.haveName = true
        }
      })
    }
    // deleteBanner (bannerId) {
    //   this.$confirm('是否确定删除该Banner?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     delBanner(bannerId).then(res => {
    //       if (res.data.success) {
    //         this.$notify({
    //           title: '成功',
    //           message: '删除成功',
    //           type: 'success'
    //         })
    //         this.queryInfo.pageNum = 1
    //         this.getBannerPage()
    //       }
    //     })
    //   })
    // }
  }
}
</script>

<style scoped lang="less">
.el-icon-s-unfold {
  color: #bfbfbf;
}

.el-icon-s-unfold:hover {
  color: #409EFF;
}

.compound {
  .add-category {
    justify-content: flex-start;
  }

  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}
</style>
